import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ReplaceParamsPipe } from 'projects/common/pipes/replace-params.pipe';
import { GtmService } from 'projects/common/services/gtm.service';
import { HotelsBoxService } from 'projects/common/services/hotelsBox.service';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { MetadataService } from 'projects/common/services/metadata.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { addRefererParam } from 'projects/common/components/offers/url-offer.utils';
import { SelectableDatesService } from '../../dates-popup/selectable-dates.service';
declare var window: any;

@Component({
    selector: 'list-offer-card',
    template: `
        <div class="list-offer-card" [ngClass]="{'-is-last': isLast}" (click)="onOfferClicked($event)">
            <div class="city">
                {{ data?.main_text || data?.link?.title || data?.destination || '' }}
            </div>
            <div class="price">
                {{ priceMessage }} {{ priceLabel }}
            </div>
        </div>
    `,
    styleUrls: ['./list-offer-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ListOfferCardComponent implements OnInit {
    @Input() data;
    @Input() currency;
    @Input() isLast: boolean;
    priceLabel: string;
    priceMessage: string;
    private isIframeDistribution: boolean;

    // tracking
    @Input() moduleId: string;
    @Input() moduleIndex: number;
    @Input() positionIndex: number;
    @Input() uniqueId?: string;
    @Input() sboxAutocomplete?: boolean;
    @Input() moduleReferer?: string;

    constructor(
        private upaService: UpaService,
        private gtmService: GtmService,
        private selectableDatesService: SelectableDatesService,
        private replaceParamsPipe: ReplaceParamsPipe,
        private hotelsBoxService: HotelsBoxService,
        private landingModelService: LandingModelService,
        private metadataService: MetadataService
    ) {
        this.isIframeDistribution =
            this.landingModelService.getLandingModel().distributionId === 'dynamicIframe';
    }

    ngOnInit() {
        this.priceLabel = this.getPriceLabel();
        this.priceMessage = this.getPriceMessage();
    }

    getPriceLabel(): string {
        if (!this.data?.price) {
            return '';
        }

        const code = this.currency?.currencyCode || this.currency?.code || 'ARS';
        const byCurrency = this.data.price[code] || Object.values(this.data.price)[0];

        return byCurrency?.price_as_string || `${byCurrency?.currency_mask ?? '$'}${byCurrency?.total_amount ?? ''}`;
    }

    getPriceMessage(): string {
        const code = this.currency?.currencyCode || this.currency?.code || 'ARS';
        const byCurrency = this.data?.price?.[code] || Object.values(this.data?.price ?? {})[0];
        return byCurrency?.message || '';
    }

    private resolvePrice(): any {
        const code = this.currency?.currencyCode || this.currency?.code || 'ARS';
        return this.data?.price?.[code] || Object.values(this.data?.price ?? {})[0];
    }

    onOfferClicked(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();

        const price = this.resolvePrice();
        const href = this.getHref(price);

        if (window.hotelsBox && this.sboxAutocomplete) {
            this.hotelsBoxService.updateHotelsData(this.data);
            if (href) this.track(href, UpaTarget.OFFER_COMPLETE_SBOX);
            return;
        }

        if (this.data.offer_alternatives?.length > 0) {
            this.selectableDatesService.openModal(
                this.currency.code,
                this.data,
                this.moduleId,
                this.moduleIndex,
                this.uniqueId
            );
            return;
        }

        if (this.data.link?.url && href) {
            this.track(href, UpaTarget.OFFER);

            const pageLoad =
                !this.metadataService.isXDespShowInfoEnabled() ||
                confirm('¿Ir al enlace?\n' + href);

            const isXSell = this.data.link.type?.toString()?.startsWith('XSELL');

            if (pageLoad) {
                window.open(href, this.isIframeDistribution || isXSell ? '_blank' : '_self');
            }
        }
    }

    private track(href: string, target: UpaTarget): void {
        this.gtmService.trackEventIfApplicable(
            'user-action',
            `offer-row-${this.moduleIndex}-position-${this.positionIndex}`,
            'Click',
            this.data.product
        );

        const destinationGid = this.data?.offer_tracking_data?.destination_gid ?? null;
        const recommendationId = this.data?.recommendation_id ?? this.data.product;
        const label = destinationGid ? `${recommendationId}|${destinationGid}` : recommendationId;

        this.upaService.trackClickTopic({
            label,
            moduleId: this.moduleId,
            moduleIndex: this.moduleIndex,
            uniqueId: this.uniqueId,
            positionIndex: this.positionIndex,
            target,
            href,
            flags: this.data.flags
        });
    }

    private getHref(price: any): string | null {
        if (this.data.offer_alternatives?.length > 0) return null;

        const url = this.data.force_domain
            ? `//${this.data.force_domain}${this.data.link.url}`
            : this.data.link.url;

        return this.replaceParamsPipe.transform(addRefererParam(
            url,
            this.moduleReferer,
            this.landingModelService.getLandingModel().refererName
        ), {
            currency: this.currency?.code,
            price: price?.total_amount_not_formatted
        });
    }

}